var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('md-toolbar',{staticClass:"md-layout md-alignment-center md-dense",attrs:{"md-elevation":"0"}},[_c('span',[_vm._v("Copyright © JON Inc. All Rights Reserved.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }